var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import HttpClient from "@/lib/http/http-client";
/**
 * Export API endpoints
 */
const EXPORTS_ENDPOINTS = {
    list: "/webapi/export/list",
    status: (id) => `/webapi/export/${id}/status`,
    download: (id) => `/webapi/export/${id}/download`,
    dismiss: (id) => `/webapi/export/${id}`,
};
/**
 * Fetch list of user exports (visible ones)
 */
export function fetchExports() {
    return __awaiter(this, void 0, void 0, function* () {
        return HttpClient.get(EXPORTS_ENDPOINTS.list);
    });
}
/**
 * Get status of a specific export
 */
export function getExportStatus(id) {
    return __awaiter(this, void 0, void 0, function* () {
        return HttpClient.get(EXPORTS_ENDPOINTS.status(id));
    });
}
/**
 * Download an export and mark it as downloaded
 */
export function downloadExport(id) {
    return __awaiter(this, void 0, void 0, function* () {
        return HttpClient.post(EXPORTS_ENDPOINTS.download(id), {});
    });
}
/**
 * Dismiss/delete an export from the list
 */
export function dismissExport(id) {
    return __awaiter(this, void 0, void 0, function* () {
        return HttpClient.delete(EXPORTS_ENDPOINTS.dismiss(id), {});
    });
}
